export default __webpack_public_path__ + "3f88b7fa0e7eab3068d6b11ae5b8cce8.mp3";